import React, { useState } from 'react';
import { CaseAndAdminForm } from '../../../../../../components';
import { modalNotification } from '../../../../../../utils';
import { CashPaymentService } from '../../../../../../services/index.service';
import { purchaseMemberShipPlan } from '../../../../../../services/Customers/customers.service';

export default function Cash({
  rowData,
  setIsOpenModal,
  getData,
  authorizedUser,
  paymentDetails,
  memberShip,
  isAlreadyActivate,
}) {
  const [formData] = useState();
  const [loading, setLoading] = useState(false);
  const onSubmit = async (value) => {
    setLoading(true);
    try {
      let bodyData = {
        ...value,
        bookingId: rowData?.BookingDetail?.bookingId,
        reason: paymentDetails?.reason,
      };
      let memberShipBodyData = {
        ...(isAlreadyActivate ? { isUpgradePlan: 1 } : ''),
        customerId: rowData?.customerId,
        membershipPlanId: rowData?.memberShipPlanId,
        durationType: rowData?.planType,
        paymentMethod: 'cash',
      };
      const response = memberShip
        ? await purchaseMemberShipPlan({ memberShipBodyData })
        : await CashPaymentService({ bodyData });
      if (response?.success) {
        modalNotification({
          type: 'success',
          message: response?.message,
        });
        setIsOpenModal(false);
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  return (
    <CaseAndAdminForm
      onSubmit={onSubmit}
      formData={formData}
      title="Collecting Cash"
      rowData={rowData}
      loading={loading}
      authorizedUser={authorizedUser}
      paymentDetails={paymentDetails}
    />
  );
}
